import React from "react";

function MiscWhyUse(props) {
  return (
    <div className="container" style={{ marginTop: "6rem" }}>
      {/* Title */}
      <div className="text-center">
        <label className="display-6 fw-bold text-dark">
          Why use {props.title}?
        </label>
      </div>

      {/* Whys use list grid */}
      {whyUSeGridListView(props.why_use)}
    </div>
  );
}

/* Grid List View */
function whyUSeGridListView(why_use_list) {
  return (
    <div className="row mt-5 justify-content-center">
      {why_use_list.map((item, index) => (
        <div className="col-md-4 my-3" key={index}>
          <div className="card border-0 justify-content-center text-center">
            <div className="card-body">
              <h5 className="card-title">{item.title}</h5>
              <p className="card-text text-muted">{item.description}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default MiscWhyUse;
